import React, { useContext, useEffect, useState } from "react";
import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";
import { Alert } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import PanelLayout from "../../../layouts/PanelLayout";

function DashboardEmpleado() {
  const { empleado } = useContext(AuthEmpleadoContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [mensajeExito, setMensajeExito] = useState(
    location.state?.mensajeExito || ""
  );

  useEffect(() => {
    if (!empleado) navigate("/loginEmpleados");
  }, [empleado, navigate]);

  useEffect(() => {
    if (location.state?.mensajeExito) {
      setMensajeExito(location.state.mensajeExito);
      window.history.replaceState({}, document.title, location.pathname);
    }
  }, [location.pathname, location.state]);

  if (!empleado) return null;

  return (
    <PanelLayout>
      <div className="container py-4 py-lg-5 dashboard-empleado">
        {mensajeExito && (
          <Alert variant="success" className="mb-4 text-center shadow-sm border-0">
            {mensajeExito}
          </Alert>
        )}

        <div className="dashboard-hero mb-4 mb-lg-5">
          <div className="row align-items-center g-4">
            <div className="col-lg-8">
              <span className="dashboard-chip mb-3 d-inline-flex">
                Portal de Empleados
              </span>
              <h1 className="dashboard-title mb-2">Panel del Docente</h1>
              <p className="dashboard-subtitle mb-0">
                Bienvenido/a {empleado.nombre}. Desde acá podés revisar tu
                perfil, acceder a tus recibos y gestionar tu cuenta.
              </p>
            </div>

            <div className="col-lg-4">
              <div className="dashboard-summary-card">
                <div className="dashboard-summary-top">
                  <div className="dashboard-avatar">
                    {empleado.nombre?.charAt(0) || "E"}
                  </div>
                  <div>
                    <div className="dashboard-summary-name">
                      {empleado.nombre} {empleado.apellido}
                    </div>
                    <div className="dashboard-summary-role">
                      {empleado.rol || "Empleado"}
                    </div>
                  </div>
                </div>

                <div className="dashboard-summary-grid">
                  <div className="dashboard-summary-item">
                    <span>CUIT</span>
                    <strong>{empleado.cuit || "-"}</strong>
                  </div>
                  <div className="dashboard-summary-item">
                    <span>Email</span>
                    <strong>{empleado.mail || "-"}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-lg-4">
            <div className="dashboard-profile-card h-100">
              <div className="dashboard-profile-header">
                <div className="dashboard-profile-avatar">
                  {empleado.nombre?.charAt(0) || "E"}
                </div>
                <div>
                  <h2 className="dashboard-profile-name mb-1">
                    {empleado.nombre} {empleado.apellido}
                  </h2>
                  <span className="dashboard-role-badge">
                    {empleado.rol || "Empleado"}
                  </span>
                </div>
              </div>

              <div className="dashboard-profile-details">
                <div className="dashboard-detail-box">
                  <span>CUIT</span>
                  <strong>{empleado.cuit || "-"}</strong>
                </div>
                <div className="dashboard-detail-box">
                  <span>Email</span>
                  <strong>{empleado.mail || "-"}</strong>
                </div>
                <div className="dashboard-detail-box">
                  <span>Estado</span>
                  <strong className="text-success">Activo</strong>
                </div>
              </div>

              <button
                type="button"
                className="btn btn-light dashboard-main-btn"
                onClick={() => navigate("/perfilEmpleado")}
              >
                Ver perfil completo
              </button>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="row g-4">
              <div className="col-md-6">
                <button
                  type="button"
                  className="dashboard-action-card h-100 text-start"
                  onClick={() => navigate("/misRecibos")}
                >
                  <div className="dashboard-action-icon">📄</div>
                  <h3>Mis Recibos</h3>
                  <p>Consultá y descargá tus recibos de sueldo de forma rápida.</p>
                  <span className="dashboard-action-link">Ir a recibos</span>
                </button>
              </div>

              <div className="col-md-6">
                <button
                  type="button"
                  className="dashboard-action-card h-100 text-start"
                  onClick={() => navigate("/cambiar-password")}
                >
                  <div className="dashboard-action-icon">🔒</div>
                  <h3>Seguridad</h3>
                  <p>Actualizá tu contraseña y mantené protegida tu cuenta.</p>
                  <span className="dashboard-action-link">Cambiar contraseña</span>
                </button>
              </div>

              <div className="col-12">
                <div className="dashboard-info-panel">
                  <div>
                    <span className="dashboard-chip dashboard-chip-light mb-2 d-inline-flex">
                      Acceso rápido
                    </span>
                    <h3 className="mb-2">Gestioná tu información sin salir del portal</h3>
                    <p className="mb-0">
                      Encontrá tus datos personales, recibos y opciones de cuenta
                      en un solo lugar, con acceso directo desde este panel.
                    </p>
                  </div>

                  <div className="dashboard-info-actions">
                    <button
                      type="button"
                      className="btn btn-success rounded-pill px-4"
                      onClick={() => navigate("/perfilEmpleado")}
                    >
                      Ver perfil
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-success rounded-pill px-4"
                      onClick={() => navigate("/misRecibos")}
                    >
                      Abrir recibos
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PanelLayout>
  );
}

export default DashboardEmpleado;
